"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));
var _constant = require("@airasia/phoenix-components/components/AmenitiesCard/constant");
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _RoomCard = require("./RoomCard.propTypes");
var _loadableComponents = _interopRequireDefault(require("loadable-components"));
var _Camera = _interopRequireDefault(require("./Camera"));
var _Utils = require("./Utils");
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var RateInfoMobile = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"RateInfoMobile" */"./RateInfoMobile"));
  });
});
var NotificationBannerInline = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"NotificationBannerInline" */"@airasia/phoenix-components/components/NotificationBannerInline"));
  });
});
var Container = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__Container",
  componentId: "sc-m0hpyp-0"
})(["max-width:100%;box-shadow:0 1px 4px rgba(0,0,0,0.16);border-radius:", ";", " font-family:", ";border:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme,
    move = _ref.move;
  return move ? theme.borderRadius.XXnormal : theme.borderRadius.normal;
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.greyLight;
});
var RoomName = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__RoomName",
  componentId: "sc-m0hpyp-1"
})(["width:100%;background:", ";border-radius:", ";display:block !important;box-sizing:border-box;padding:", ";min-height:", ";color:", ";font-size:", ";line-height:", ";font-weight:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.backgroundColor.default;
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.micro, " 0 0");
}, function (_ref7) {
  var theme = _ref7.theme,
    isHasTag = _ref7.isHasTag;
  return !isHasTag ? "".concat(theme.space.small, " ").concat(theme.space.XSmall, " ").concat(theme.space.tiny, " ").concat(theme.space.XSmall) : "".concat(theme.space.tiny, " ").concat(theme.space.XSmall, " ").concat(theme.space.tiny, " ").concat(theme.space.XSmall);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.semiLarge;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.neutral;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize.titleSmall;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.lineHeight.XXLarge;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontWeight.medium;
});
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__Wrapper",
  componentId: "sc-m0hpyp-2"
})(["position:relative;display:flex;flex-direction:column;box-shadow:0px 1px 4px rgba(0,0,0,0.16);border-bottom:1px solid ", ";", " ", ""], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.greyLight;
}, function (_ref14) {
  var isMobile = _ref14.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref15) {
  var isMobile = _ref15.isMobile,
    highlight = _ref15.highlight,
    theme = _ref15.theme;
  return highlight && !isMobile ? "\n    border: 1px solid ".concat(theme.colors.secondary, ";\n    border-radius: 0 0 ").concat(theme.space.micro, " ").concat(theme.space.micro, ",\n    border-top: 0,\n    ") : "";
});
var ImagesWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__ImagesWrapper",
  componentId: "sc-m0hpyp-3"
})(["width:100%;background-color:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.backgroundColor.greyLighter;
});
var HeroImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__HeroImageWrapper",
  componentId: "sc-m0hpyp-4"
})(["display:grid;grid-template-row:10rem 10rem 10rem;"]);
var LowerThumbnailImage = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__LowerThumbnailImage",
  componentId: "sc-m0hpyp-5"
})(["flex:1 1 auto;height:9.8vw;background:#000;opacity:1;width:'100%';height:200;marin-top:100px;"]);
var ImageDarken = _styledComponents.default.image.withConfig({
  displayName: "RoomCardMobile__ImageDarken",
  componentId: "sc-m0hpyp-6"
})(["opacity:0.7;padding-top:-10px;cursor:pointer;"]);
var AmenitiesWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__AmenitiesWrapper",
  componentId: "sc-m0hpyp-7"
})(["background-color:", ";padding-top:13px;"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.backgroundColor.default;
});
var AmenityWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__AmenityWrapper",
  componentId: "sc-m0hpyp-8"
})(["display:grid;grid-template-columns:auto auto auto auto;grid-row-gap:", ";grid-template-columns:auto auto;padding-left:", ";padding-bottom:", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.tiny;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.XSmall;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.XSmall;
});
var AmenityContainer = _styledComponents.default.span.withConfig({
  displayName: "RoomCardMobile__AmenityContainer",
  componentId: "sc-m0hpyp-9"
})(["color:", ";font-style:normal;font-weight:normal;font-size:", ";line-height:", ";display:flex;align-items:center;padding:", ";margin-right:", ";display:inline-flex;"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.greyDark;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.fontSize.small;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.lineHeight.small;
}, function (_ref24) {
  var theme = _ref24.theme;
  return "".concat(theme.space.mini, " 0");
}, function (_ref25) {
  var theme = _ref25.theme;
  return "".concat(theme.space.XSmall);
});
var ShowAllAmenitiesLabel = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__ShowAllAmenitiesLabel",
  componentId: "sc-m0hpyp-10"
})(["color:", ";font-size:", ";line-height:", ";font-weight:", ";padding-top:", ";cursor:pointer;margin-top:-9px;position:relative;display:flex;align-items:center;"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.tertiaryRed;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.fontSize.XSmall;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontWeight.medium;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.space.tiny;
});
var ImagesAmountWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__ImagesAmountWrapper",
  componentId: "sc-m0hpyp-11"
})(["position:absolute;z-index:2;color:", ";margin-left:7vw;margin-top:4vw;font-size:14px;display:flex;align-items:center;border-radius:", ";cursor:pointer;"], function (_ref31) {
  var theme = _ref31.theme;
  return theme.colors.default;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.borderRadius.XLarge;
});
var RoomInfoWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__RoomInfoWrapper",
  componentId: "sc-m0hpyp-12"
})(["padding:", ";"], function (_ref33) {
  var theme = _ref33.theme;
  return "0 ".concat(theme.space.small, " ").concat(theme.space.XSmall, " ").concat(theme.space.XSmall, "}");
});
var Divider = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__Divider",
  componentId: "sc-m0hpyp-13"
})(["border-bottom:", ";background:", ";"], function (_ref34) {
  var theme = _ref34.theme;
  return "1px solid".concat(theme.colors.greyLight);
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.backgroundColor.default;
});
var TagsWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__TagsWrapper",
  componentId: "sc-m0hpyp-14"
})(["display:flex;padding:", ";background-color:", ";"], function (_ref36) {
  var theme = _ref36.theme;
  return "".concat(theme.space.XSmall, " ").concat(theme.space.XSmall, " 0 ").concat(theme.space.XSmall);
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.backgroundColor.default;
});
var TagWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__TagWrapper",
  componentId: "sc-m0hpyp-15"
})(["background-color:", ";color:", ";padding:", ";font-size:", ";line-height:", ";border-radius:", ";font-weight:", ";margin-right:", ";"], function (_ref38) {
  var theme = _ref38.theme,
    backgroundColor = _ref38.backgroundColor;
  return !backgroundColor ? theme.backgroundColor.blueLight : theme.backgroundColor[backgroundColor];
}, function (_ref39) {
  var theme = _ref39.theme,
    color = _ref39.color;
  return !color ? theme.colors.secondary : theme.colors[color];
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.space.micro;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.fontSize.XSmall;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.lineHeight.small;
}, function (_ref43) {
  var theme = _ref43.theme,
    borderRadius = _ref43.borderRadius;
  return !borderRadius ? theme.borderRadius.normal : theme.borderRadius[borderRadius];
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.fontWeight.medium;
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.space.micro;
});
var LowInventoryWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__LowInventoryWrapper",
  componentId: "sc-m0hpyp-16"
})(["width:100%;background:", ";border-radius:", ";display:block !important;box-sizing:border-box;padding:", ";"], function (_ref46) {
  var theme = _ref46.theme;
  return theme.backgroundColor.default;
}, function (_ref47) {
  var theme = _ref47.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.micro, " 0 0");
}, function (_ref48) {
  var theme = _ref48.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.small, " ").concat(theme.space.XSmall, " ").concat(theme.space.XSmall);
});
var ImageContainer = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__ImageContainer",
  componentId: "sc-m0hpyp-17"
})(["display:flex;flex-direction:row;height:20vw;object-fit:cover;width:100%;"]);
var DividerWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__DividerWrapper",
  componentId: "sc-m0hpyp-18"
})(["margin-left:14px;margin-right:14px;"]);
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__IconWrapper",
  componentId: "sc-m0hpyp-19"
})(["font-size:24px;margin-right:5px;margin-bottom:3px;"]);
var LowInventoryHotelRooms = _styledComponents.default.div.withConfig({
  displayName: "RoomCardMobile__LowInventoryHotelRooms",
  componentId: "sc-m0hpyp-20"
})(["position:absolute;top:5px;right:5px;height:23px;padding:4px 12px;border-radius:50px;border:1px solid #c94318;gap:5px;background:#c94318;display:flex;align-items:center;font-family:'DM Sans';font-size:0.9rem;font-weight:400;line-height:18px;letter-spacing:0em;text-align:right;color:#ffffff;padding-left:12px;padding-right:12px;white-space:nowrap;z-index:2;"]);
var Amenity = function Amenity(_ref49) {
  var amenities = _ref49.amenities,
    showMore = _ref49.showMore,
    onShowAmenitiesHandler = _ref49.onShowAmenitiesHandler;
  var showAble = amenities.slice(0, 5);
  return /*#__PURE__*/_react.default.createElement(AmenityWrapper, null, showAble.map(function (amenity) {
    var iconName = (amenity === null || amenity === void 0 ? void 0 : amenity.displayId) && _constant.ROOM_AMENITIES_OTHER_ICONS[amenity === null || amenity === void 0 ? void 0 : amenity.displayId] || _constant.ICON_ROOM_AMENITIES[amenity === null || amenity === void 0 ? void 0 : amenity.id];
    return /*#__PURE__*/_react.default.createElement(AmenityContainer, {
      key: "room-amenity-".concat(amenity.id)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: iconName,
      color: "greyDark",
      width: "14",
      height: "14"
    }), /*#__PURE__*/_react.default.createElement(_Label.default, {
      textColor: "greyDark"
    }, " ", amenity.name, " "));
  }), amenities.length > 5 && /*#__PURE__*/_react.default.createElement(ShowAllAmenitiesLabel, {
    onClick: function onClick() {
      return onShowAmenitiesHandler();
    }
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, "+"), " ", showMore));
};
Amenity.propTypes = _RoomCard.RoomCardPropTypes;
Amenity.defaultProps = _RoomCard.RoomCardDefaultValues;
var RoomCardMobile = function RoomCardMobile(_ref50) {
  var accessible = _ref50.accessible,
    name = _ref50.name,
    isMobile = _ref50.isMobile,
    _ref50$images = _ref50.images,
    images = _ref50$images === void 0 ? [] : _ref50$images,
    _ref50$amenities = _ref50.amenities,
    amenities = _ref50$amenities === void 0 ? [] : _ref50$amenities,
    theme = _ref50.theme,
    heroImage = _ref50.heroImage,
    isImageGalleryEnabled = _ref50.isImageGalleryEnabled,
    _ref50$translations = _ref50.translations,
    translations = _ref50$translations === void 0 ? {} : _ref50$translations,
    _ref50$occupancy = _ref50.occupancy,
    occupancy = _ref50$occupancy === void 0 ? {} : _ref50$occupancy,
    openImageGallery = _ref50.openImageGallery,
    hotelName = _ref50.hotelName,
    roomAmenityName = _ref50.roomAmenityName,
    roomAmenity = _ref50.roomAmenity,
    hotelNameVar = _ref50.hotelNameVar,
    _ref50$rates = _ref50.rates,
    rates = _ref50$rates === void 0 ? [] : _ref50$rates,
    isShowRateName = _ref50.isShowRateName,
    onSelectRoomHandler = _ref50.onSelectRoomHandler,
    onShowAmenitiesHandler = _ref50.onShowAmenitiesHandler,
    onShowRateDetailHandler = _ref50.onShowRateDetailHandler,
    isSingleOption = _ref50.isSingleOption,
    bigMembership = _ref50.bigMembership,
    applyBigpoints = _ref50.applyBigpoints,
    _ref50$roomOccupancy = _ref50.roomOccupancy,
    roomOccupancy = _ref50$roomOccupancy === void 0 ? {} : _ref50$roomOccupancy,
    isSnap = _ref50.isSnap,
    roomsLeft = _ref50.roomsLeft,
    locale = _ref50.locale,
    rateDiscounts = _ref50.rateDiscounts,
    soldOutBedGroupTokens = _ref50.soldOutBedGroupTokens,
    lowInventoryFOMO = _ref50.lowInventoryFOMO,
    move = _ref50.move,
    isBlockedRateIsEnabled = _ref50.isBlockedRateIsEnabled;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var thumbnailImages = images.slice(1, 3);
  var thumbnailImagesSmall = thumbnailImages[0];
  var lowerImage = thumbnailImages[1];
  var showMore = translations.showMore;
  var _ref51 = rates.length > 0 ? rates[0] : {},
    recommendedText = _ref51.recommendedText,
    flierDiscountText = _ref51.flierDiscountText;
  var getMain = function getMain(_ref52) {
    var _thumbnailImagesSmall;
    var imageList = _ref52.imageList;
    return /*#__PURE__*/_react.default.createElement(Container, {
      tabIndex: tabIndex,
      move: move
    }, /*#__PURE__*/_react.default.createElement(Wrapper, {
      tabIndex: tabIndex
    }, rates && lowInventoryFOMO && lowInventoryFOMO.message && /*#__PURE__*/_react.default.createElement(LowInventoryHotelRooms, null, lowInventoryFOMO.message), /*#__PURE__*/_react.default.createElement(ImagesWrapper, null, isImageGalleryEnabled ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, images.length <= 2 ? /*#__PURE__*/_react.default.createElement(ImageContainer, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '200%'
      }
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: heroImage,
      alt: name,
      width: "100%",
      height: "100%",
      centerFocus: true,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE,
      style: {
        objectFit: 'contain'
      }
    }))) : /*#__PURE__*/_react.default.createElement(ImageContainer, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '200%'
      }
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: heroImage,
      alt: name,
      width: "100%",
      height: "20vw",
      centerFocus: true,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE,
      style: {
        objectFit: 'contain'
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        height: '9.8vw',
        width: '100%',
        paddingLeft: '3px'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingBottom: '3px'
      }
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: thumbnailImagesSmall === null || thumbnailImagesSmall === void 0 || (_thumbnailImagesSmall = thumbnailImagesSmall.links) === null || _thumbnailImagesSmall === void 0 ? void 0 : _thumbnailImagesSmall.small,
      alt: (thumbnailImagesSmall === null || thumbnailImagesSmall === void 0 ? void 0 : thumbnailImagesSmall.caption) || 'TBD',
      width: "100%",
      height: "9.8vw",
      centerFocus: true,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE,
      style: {
        objectFit: 'fill'
      }
    })), images.length === 3 ? /*#__PURE__*/_react.default.createElement(LowerThumbnailImage, {
      onClick: openImageGallery
    }, /*#__PURE__*/_react.default.createElement(ImagesAmountWrapper, null, /*#__PURE__*/_react.default.createElement(_Camera.default, null), /*#__PURE__*/_react.default.createElement(_Label.default, {
      textColor: "default"
    }, "+ ", translations === null || translations === void 0 ? void 0 : translations.morePhoto)), /*#__PURE__*/_react.default.createElement(ImageDarken, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: lowerImage === null || lowerImage === void 0 ? void 0 : lowerImage.links.small,
      alt: lowerImage.caption || 'TBD',
      width: "100%",
      height: "9.8vw",
      centerFocus: true,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE
    }))) : /*#__PURE__*/_react.default.createElement(LowerThumbnailImage, {
      onClick: openImageGallery
    }, /*#__PURE__*/_react.default.createElement(ImagesAmountWrapper, null, /*#__PURE__*/_react.default.createElement(_Camera.default, null), /*#__PURE__*/_react.default.createElement(_Label.default, {
      textColor: "default"
    }, "+ ", imageList.length - 3, " ", translations === null || translations === void 0 ? void 0 : translations.photo)), /*#__PURE__*/_react.default.createElement(ImageDarken, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: lowerImage === null || lowerImage === void 0 ? void 0 : lowerImage.links.small,
      alt: (lowerImage === null || lowerImage === void 0 ? void 0 : lowerImage.caption) || 'TBD',
      width: "100%",
      height: "9.8vw",
      centerFocus: true,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE
    })))))) : /*#__PURE__*/_react.default.createElement(HeroImageWrapper, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: heroImage,
      alt: name,
      width: "80%",
      height: "100%",
      centerFocus: true,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE
    })), isSingleOption && ((0, _Utils.isNotEmpty)(recommendedText) || (0, _Utils.isNotEmpty)(flierDiscountText)) && /*#__PURE__*/_react.default.createElement(TagsWrapper, null, (0, _Utils.isNotEmpty)(recommendedText) && /*#__PURE__*/_react.default.createElement(TagWrapper, {
      color: move && 'oldSecondary',
      borderRadius: move && 'XXnormal'
    }, recommendedText), (0, _Utils.isNotEmpty)(flierDiscountText) && /*#__PURE__*/_react.default.createElement(TagWrapper, {
      color: move && 'oldSecondary',
      borderRadius: move && 'XXnormal'
    }, flierDiscountText)), /*#__PURE__*/_react.default.createElement(RoomName, {
      isHasTag: isSingleOption && ((0, _Utils.isNotEmpty)(recommendedText) || (0, _Utils.isNotEmpty)(flierDiscountText))
    }, hotelName, hotelNameVar, " ", name), /*#__PURE__*/_react.default.createElement(DividerWrapper, null, /*#__PURE__*/_react.default.createElement(Divider, null)), Array.isArray(amenities) && amenities.length > 0 && /*#__PURE__*/_react.default.createElement(AmenitiesWrapper, null, /*#__PURE__*/_react.default.createElement(Amenity, {
      amenities: amenities,
      showMore: showMore,
      onShowAmenitiesHandler: onShowAmenitiesHandler
    })), /*#__PURE__*/_react.default.createElement(LowInventoryWrapper, null, roomsLeft && /*#__PURE__*/_react.default.createElement(NotificationBannerInline, {
      accessible: true,
      border: false,
      closable: false,
      ctaColor: "primaryDark",
      device: "mobile",
      fullWidth: true,
      message: roomsLeft,
      showLeftIcon: true,
      smallerPadding: false,
      textType: "small",
      theme: theme,
      type: "error"
    }))), Array.isArray(rates) && rates.length > 0 && /*#__PURE__*/_react.default.createElement(RoomInfoWrapper, null, rates.map(function (rate, index) {
      var _lowInventoryFOMO$rat;
      var promo = (0, _Utils.getPromoValue)(rate.id, rateDiscounts);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(RateInfoMobile, {
        key: "rate-".concat(rate.id),
        rate: rate,
        isShowRateName: isShowRateName,
        applyBigpoints: applyBigpoints,
        bigMembership: bigMembership,
        isMobile: isMobile,
        index: index,
        translations: translations,
        occupancy: occupancy,
        promoTitle: promo.title,
        discountType: promo.type,
        onSelectRoomHandler: onSelectRoomHandler,
        onShowRateDetailHandler: onShowRateDetailHandler,
        isSingleOption: isSingleOption,
        roomOccupancy: roomOccupancy,
        isSnap: isSnap,
        roomAmenity: roomAmenity,
        roomAmenityName: roomAmenityName,
        locale: locale,
        soldOutBedGroupTokens: soldOutBedGroupTokens,
        lowInventoryFOMO: ((_lowInventoryFOMO$rat = lowInventoryFOMO.rate) === null || _lowInventoryFOMO$rat === void 0 || (_lowInventoryFOMO$rat = _lowInventoryFOMO$rat[Number(rate.id)]) === null || _lowInventoryFOMO$rat === void 0 ? void 0 : _lowInventoryFOMO$rat.option) || '',
        isBogoPromoEnabled: rate === null || rate === void 0 ? void 0 : rate.isBogoEnabled,
        bogoMessage: rate === null || rate === void 0 ? void 0 : rate.bogoMessage,
        bogoTag: rate === null || rate === void 0 ? void 0 : rate.bogoTag,
        move: move,
        isBlockedRateIsEnabled: isBlockedRateIsEnabled
      }));
    }))));
  };
  getMain.propTypes = _RoomCard.getMainPropType;
  return themeContext ? getMain({
    imageList: images
  }) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain({
    imageList: images
  }));
};
RoomCardMobile.propTypes = _RoomCard.RoomCardPropTypes;
RoomCardMobile.defaultProps = _RoomCard.RoomCardDefaultValues;
var _default = RoomCardMobile;
exports.default = _default;